import axios from "axios";
import config from "config/index";
//@ts-ignore
import { notify } from "@microui/react-ui";

export function createBaseInstance(baseURL) {
  const instance = axios.create({
    baseURL,
    timeout: config.request.timeout,
    withCredentials: false,
    headers: {
      "Content-Type": "application/json",
    },
  });
  let errorCount = 0;

  instance.interceptors.request.use(
    (cfg) =>
      new Promise((resolve) => {
        if (typeof window !== "undefined") {
          cfg.headers.Authorization = (window as any).token;
        }

        resolve(cfg);
      }),
    (error) => {
      console.error(`${baseURL} =>`, error);
      return error;
    }
  );

  instance.interceptors.response.use(
    (response: any) =>
      new Promise((resolve, reject) => {
        errorCount = 0;

        try {
          resolve(response.data);
        } catch (err) {
          reject(err);
        }
      }),
    (error) =>
      new Promise((resolve, reject) => {
        console.error(`${baseURL} =>`, error.response.data);

        try {
          if (
            error.response.status == 401 &&
            errorCount < config.request.maxRetryError
          ) {
            errorCount += 1;

            this.props.refreshToken((err, token) => {
              if (err) return reject(err);

              if (typeof window !== "undefined") {
                (window as any).token = token;
              }

              return resolve(instance(error.config));
            });
          } else {
            errorCount = 0;
            const errors = Object.keys(error.response.data.errors).map(
              (key) => error.response.data.errors[key]
            );
            notify.error(
              `Lỗi #${error.response.status}. ${errors.join(". ")}.`
            );
            return reject(error.response.data.error);
          }
        } catch (e) {
          return reject(error);
        }
      })
  );

  return instance;
}
